/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react'; // eslint-disable-line

import { Button, Divider, Grid, Tooltip, Typography, withStyles } from '@material-ui/core';
import { Cached, CheckCircle, Edit, Warning } from '@material-ui/icons';
import { connect, MapDispatchToProps } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { getKeyTaxDirective, KeyTaxDirective } from './reducer';
import styles, { StyledComponent } from '../../../styles/styles';
import { OpenDialog, openDialogAction } from '../../../confirmation-dialog';
import { OpenEditModal, openEditModalAction } from '../../../form-modal/actions';
import {
    ButtonWrapper,
    FullWidthDatePicker,
    FullWidthSearchSelectField,
    FullWidthSelectField,
    FullWidthTextField,
    validations,
} from '../../../forms';
import { LabeledValue } from '../../../controls/labeled-value';
import { EditFormModal } from '../../../form-modal';
import {
    UpdateAndSubmitKeyTaxDirective,
    updateAndSubmitKeyTaxDirectiveThunk,
} from '../../actions/key-tax-deirective-record';
import { State } from '../../../redux/root-reducer';
import { requiredValidator } from '../../../forms/validations';
import { CurrencyMask } from '../../../forms/input-masks/currency-mask';
import { NumberMask } from '../../../forms/input-masks/number-mask';
import { convertToNumber, formatCurrency, getDisplayDate } from '../../../shared-functions';
import { getLifeAssuredDetails } from '../../../life-assured-details/reducer';
import { Field } from 'react-final-form';
import { ClaimDecision, getDecisions } from '../../reducer';
import { getClaim } from '../../../claim';
import {
    UpdateTaxDirective,
    updateTaxDirectiveActionAction,
} from '../../actions/update-tax-directives';

interface OwnProps {
    index: number;
    keyTaxDirective: KeyTaxDirective;
    disabledbuttonForAssessor?: boolean;
}

interface StateProps {
    keyTaxDirectiveSummary: KeyTaxDirective[];
    isReadOnly: boolean;
    keyTaxDirectiveDeclaration?: string;
    decisions: ClaimDecision[];
}

interface DispatchProps {
    updateRecord: UpdateAndSubmitKeyTaxDirective;
    openEditModal: OpenEditModal;
    openDialog: OpenDialog;
    updateTaxDirectives: UpdateTaxDirective;
}

type Props = DispatchProps & OwnProps & StateProps & StyledComponent;

const keyTaxDirectiveDetailsView: React.FunctionComponent<any> = ({
    classes,
    index,
    keyTaxDirectiveSummary,
    openEditModal,
    updateRecord,
    keyTaxDirective,
    keyTaxDirectiveDeclaration,
    decisions,
    updateTaxDirectives,
}: Props) => {
    if (keyTaxDirectiveDeclaration === 'No') {
        return null;
    }
    const decision = decisions.find(c => c.decisionId === keyTaxDirective.decisionId);
    let directivestatus = 'Request Failed. Please Contact Support team';
    if (keyTaxDirective.taxDirectiveStatus === undefined) {
        directivestatus = 'Pending';
    } else if (keyTaxDirective.taxDirectiveStatus === '200') {
        directivestatus = 'Successful';
    }

    return (
        <>
            <Grid container spacing={5}>
                <Grid item xs={12} className={classes.marginTop3}>
                    <ButtonWrapper>
                        <Grid item container xs={12} justify="flex-end">
                            {editKeyTaxDirectiveButton(
                                keyTaxDirectiveSummary,
                                index,
                                updateRecord,
                                openEditModal,
                                decisions,
                                classes
                            )}
                        </Grid>
                    </ButtonWrapper>
                </Grid>
                <Grid item xs={4} lg={2}>
                    <LabeledValue label="Policy" value={decision?.policyNumber} />
                </Grid>
                <Grid item xs={4} lg={2}>
                    <LabeledValue
                        label="Date Requested"
                        value={getDisplayDate(keyTaxDirective.dateRequested)}
                    />
                </Grid>
                <Grid item xs={4} lg={2}>
                    <LabeledValue label="Amount Applied" value={keyTaxDirective.amountApplied} />
                </Grid>
                <Grid item xs={4} lg={4}>
                    <LabeledValue
                        label="Directive Number"
                        value={keyTaxDirective.keyTaxReferenceNumber}
                    />
                </Grid>
                <Grid item xs={4} lg={4}>
                    <LabeledValue
                        label="Tax Directive Valid For This Period"
                        value={
                            getDisplayDate(keyTaxDirective.startDate) +
                            '  -  ' +
                            getDisplayDate(keyTaxDirective.endDate)
                        }
                    />
                </Grid>
                <Grid item xs={4} lg={4}>
                    <LabeledValue
                        label="Date Returned/Response Date"
                        value={getDisplayDate(keyTaxDirective.dateRequested)}
                    />
                </Grid>
                <Grid item xs={4} lg={4}>
                    <LabeledValue
                        label="SARS amount"
                        value={formatCurrency(keyTaxDirective.amountReturned)}
                    />
                </Grid>
                <Grid item xs={4} lg={4}>
                    <LabeledValue label="Source Code" value={keyTaxDirective.sourceCode} />
                </Grid>
                <Grid item xs={4} lg={4}>
                    <LabeledValue label="Status" value={keyTaxDirective.status} />
                </Grid>
                <Divider />
            </Grid>
            <Grid item xs={12} lg={12} justify="flex-start">
                <ButtonWrapper>
                    <Button
                        id="AddDirectiveItem"
                        color="secondary"
                        style={{
                            marginBottom: 30,
                            marginTop: '3%',
                            textTransform: 'none',
                        }}
                        onClick={() => updateTaxDirectives(keyTaxDirective?.decisionId)}
                    >
                        <Cached />
                        Send tax Directive to Compass
                    </Button>
                </ButtonWrapper>
                Status:{directivestatus}
                {checkDirectiveStatus(directivestatus === '200')}
            </Grid>
        </>
    );
    function checkDirectiveStatus(taxStatus?: boolean) {
        if (taxStatus) {
            return <CheckCircle style={{ color: '#36b37e', marginLeft: '8px' }} />;
        } else {
            return <Warning style={{ color: '#ff6c35', marginLeft: '8px' }} />;
        }
    }
};

const KeyTaxDirectiveEditFormModal = EditFormModal<KeyTaxDirective>();
const editKeyTaxDirectiveButton = (
    keyTaxDirectives: KeyTaxDirective[],
    keyTaxDirectiveIndex: number,
    updateRecord: UpdateAndSubmitKeyTaxDirective,
    openEditModal: OpenEditModal,
    decisions: ClaimDecision[],
    classes: any
) => {
    const openEditView = () => {
        openEditModal({
            modalContent: (
                <KeyTaxDirectiveEditFormModal
                    recordDetailView={
                        <KeytaxDirectiveDetailView
                            classes={classes}
                            heading="Edit Tax Directive feedback from KeyTax"
                            decisions={decisions}
                        />
                    }
                    records={keyTaxDirectives}
                    updateRecord={(keyTaxDirective, index) => updateRecord(index, keyTaxDirective)}
                />
            ),
            modalData: {
                recordIndex: keyTaxDirectiveIndex,
            },
        });
    };

    return (
        <ButtonWrapper>
            <Tooltip title="Edit Key Tax Directive">
                <Button id="EditKeyTaxDirective" color="secondary" onClick={openEditView}>
                    <Edit />
                </Button>
            </Tooltip>
        </ButtonWrapper>
    );
};

type MiniProps = StyledComponent & {
    heading: React.ReactNode;
    decisions: ClaimDecision[];
};
const KeytaxDirectiveDetailView = ({ heading, classes, decisions }: MiniProps) => {
    return (
        <React.Fragment>
            <Typography variant="h5" className={classes.spacedTypography}>
                {heading}
            </Typography>
            <Grid container spacing={2} style={{ margin: '20px' }}>
                <Grid container spacing={2} justify="flex-start">
                    <Grid item xs={4}>
                        <FullWidthSearchSelectField
                            name="decisionId"
                            label="Policy"
                            validate={requiredValidator}
                            options={filterDecisions(decisions)}
                            disabled={false}
                        />
                    </Grid>
                    <Field
                        name="."
                        subscription={{ value: true }}
                        component={({ input: { value: values } }) => {
                            setMaximumAmountPayable(values);
                            return null;
                        }}
                    />
                    <Grid item xs={4}>
                        <FullWidthDatePicker
                            name="dateRequested"
                            validate={requiredValidator}
                            disableFuture
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <FullWidthTextField
                            name="amountApplied"
                            mask={CurrencyMask}
                            validate={validations.requiredValidator}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={2} justify="flex-start">
                    <Grid item xs={4}>
                        <FullWidthTextField
                            name="keyTaxReferenceNumber"
                            label="Directive Number"
                            validate={validations.requiredValidator}
                            mask={NumberMask}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <FullWidthDatePicker
                            name="dateReturned"
                            validate={requiredValidator}
                            disableFuture
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <FullWidthTextField
                            name="amountReturned"
                            label="SARS amount"
                            mask={CurrencyMask}
                            parse={convertToNumber}
                            validate={requiredValidator}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={2} justify="flex-start">
                    <Grid item xs={4}>
                        <FullWidthTextField
                            name="sourceCode"
                            label="Source code"
                            validate={validations.requiredValidator}
                            mask={NumberMask}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <FullWidthSelectField
                            name="status"
                            options={[
                                {
                                    value: 'Successful',
                                    label: 'Successful',
                                },
                                {
                                    value: 'unsuccessful',
                                    label: 'unsuccessful',
                                },
                                {
                                    value: 'Pending',
                                    label: 'Pending',
                                },
                            ]}
                            validate={requiredValidator}
                        />
                    </Grid>
                    <Grid
                        container
                        spacing={2}
                        justify="flex-start"
                        style={{ marginBottom: '40px' }}
                    >
                        <Grid item xs={12}>
                            <LabeledValue label="The tax directive is valid for this period:" />
                        </Grid>
                        <Grid style={{ marginTop: '50px' }}>
                            <Typography>From:</Typography>
                        </Grid>
                        <Grid item xs={4}>
                            <FullWidthDatePicker label="Date" name="startDate" disableFuture />
                        </Grid>
                        <Grid style={{ marginTop: '50px' }}>
                            <Typography>To:</Typography>
                        </Grid>
                        <Grid item xs={4}>
                            <FullWidthDatePicker label="Date" name="endDate" />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </React.Fragment>
    );
};

function filterDecisions(decisions: ClaimDecision[]) {
    const filteredDecisions: any = [];
    decisions.forEach(d => {
        filteredDecisions.push({
            value: d.decisionId,
            label: d.decisionLabel,
        });
    });
    return filteredDecisions;
}

function setMaximumAmountPayable(values: any) {
    values.maxValue = values.maximumAmountPayable;
}

const mapStateToProps = (state: State) => {
    const lifeAssured = getLifeAssuredDetails(state);
    const claim = getClaim(state);
    return {
        keyTaxDirectiveSummary: getKeyTaxDirective(state),
        keyTaxDirectiveDeclaration: lifeAssured.keyTaxDirectiveDeclaration,
        decisions: getDecisions(claim),
    };
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = (
    dispatch: ThunkDispatch<State, any, AnyAction>
) => ({
    updateRecord: (index: number, keyTaxDirective: KeyTaxDirective) =>
        dispatch(updateAndSubmitKeyTaxDirectiveThunk(index, keyTaxDirective)),
    openEditModal: options => dispatch(openEditModalAction(options)),
    openDialog: options => dispatch(openDialogAction(options)),
    updateTaxDirectives: options => dispatch(updateTaxDirectiveActionAction(options)),
});

export const KeyTaxDirectiveDetailsView = connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(keyTaxDirectiveDetailsView));
